import React from 'react'

export const CorreoAsignacion = (props) => {
    return (
        <div>

            <p>Correo Asignación.</p>

            <img src={'https://were.ppf.com.hn/web/assets/firmaCorreo.png'} alt=''/>

        </div>
    )
}